import { makeStyles, Box } from '@material-ui/core'
import React from 'react'
import { verifyExtension } from '../../shared/constants'
import CustomButton from '../CustomButton'
import CustomDialog from '../CustomDialog'
import CustomImage from '../CustomImage'
import ReactPlayer from 'react-player/lazy'
const useStyles = makeStyles((theme) => ({
  image: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
      height: '100%',
    },
  },
}))

export default function ImageDialog({ image, open, handleClose }) {
  const classes = useStyles()
  // console.log({ CHECK: verifyExtension(image.split('?')[0]), image: image.split('?')[0] })
  return (
    <CustomDialog open={open} handleClose={handleClose}>
      {image && verifyExtension(image) === 'image' ? <CustomImage image={image} className={classes.image} /> : <ReactPlayer url={image} controls playing playIcon fallback width={'100%'} />}
      <br />
      <br />
      <Box display="flex" justifyContent="center">
        <CustomButton text="Close" handleSubmit={handleClose} />
      </Box>
    </CustomDialog>
  )
}
